import { initForethought } from './forethought';
import { initZendesk } from './zendesk';
import initSentry from './sentry';
import { initNewRelic } from './newrelic';
import { pendoTrack, pendoPageLoad, getCompanyContext, getUserContext } from './pendo';
import { isNative, isWindows } from '../../../shared/utils/is';

const initPendo = () => {
    if (typeof window.pendo !== 'undefined' && window.pendo._initialized) {
        return; // Already initialized
    }

    // Load Pendo script dynamically
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://cdn.pendo.io/agent/static/ffb4ea41-bd69-4d43-b66e-fe9e062cfc77/pendo.js';

    script.onload = () => {
        // Initialize Pendo with user and company context once script loads
        if (window.pendo && !window.pendo._initialized) {
            const user = $f.active_user;
            const company = user && user.get('company');

            window.pendo.initialize({
                visitor: {
                    id: user ? user.id : '',
                    email: user ? user.email : '',
                    full_name: user ? user.get('display_name') : '',
                    role: user ? user.get('role') : ''
                },
                account: {
                    id: company ? company.id : '',
                    name: company ? company.name : ''
                }
            });

            window.pendo._initialized = true;
        }
    };

    document.head.appendChild(script);
};

export const setupLogging = async () => {
    if (isNative() && !isWindows()) {
        await initNewRelic();
    }

    initSentry();
    initPendo();

    if ($f.active_user.is_logged_in()) {
        await initForethought();
    }

    if ($f.active_user.is_logged_in()) {
        await initZendesk();
    }
};

export { pendoTrack, pendoPageLoad, getUserContext, getCompanyContext };
